module.exports = __webpack_public_path__ + "img/cover.507b56af.jpg";